import { FileText, Download, Loader2 } from "lucide-react";
import { BACKEND_URL, fmtM, fmtPct } from "../../lib/api";

export const MemoPanel = ({ memoJob, onGenerate, disabled }) => {
  const running = memoJob && ["queued", "running"].includes(memoJob.status);
  const done = memoJob?.status === "done" && memoJob.result;
  const m = done ? memoJob.result.metricas : null;
  return (
    <section className="panel relative overflow-hidden bg-[#111111] p-6 text-white lg:p-10" data-testid="memo-panel">
      <div className="grid gap-8 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <p className="eyebrow !text-orange-400">Entregable</p>
          <h2 className="font-serif-display mt-2 text-3xl font-bold sm:text-4xl">Credit Memo — Crédito PYME</h2>
          <p className="mt-3 max-w-xl text-sm text-zinc-400">9 secciones + Anexo A. Cálculos del motor, alertas cruzadas y narrativa redactada por Claude Sonnet 5.5 a partir de los trabajos completados.</p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <button data-testid="generar-memo-prueba-button" onClick={onGenerate} disabled={disabled || running} className="btn-orange flex items-center gap-2 px-6 py-3 text-sm font-semibold">
              {running ? <Loader2 size={16} className="animate-spin" /> : <FileText size={16} />} Generar memo de prueba
            </button>
            {done && (
              <a data-testid="descargar-memo-pdf-button" href={`${BACKEND_URL}${memoJob.result.pdf_url}`} target="_blank" rel="noreferrer"
                className="flex items-center gap-2 border border-zinc-600 px-6 py-3 text-sm font-semibold transition-colors hover:border-orange-500 hover:text-orange-400">
                <Download size={16} /> Descargar PDF
              </a>
            )}
          </div>
          {memoJob && (
            <div className="mt-6 max-w-xl" data-testid="memo-progress">
              <div className="h-1 w-full bg-zinc-800"><div className={`bar-fill h-1 ${memoJob.status === "error" ? "bg-red-500" : "bg-orange-500"}`} style={{ width: `${memoJob.progress}%` }} /></div>
              <p className="mt-2 text-xs text-zinc-400" data-testid="memo-status-message">{memoJob.message} · {memoJob.progress}%</p>
            </div>
          )}
          {disabled && <p className="mt-4 text-xs text-zinc-500">Espera a que terminen los trabajos activos.</p>}
        </div>
        {m && (
          <dl className="stagger grid grid-cols-2 gap-5 self-end lg:col-span-5" data-testid="memo-metrics">
            {[["Monto total", fmtM(m.monto_total)], ["TIR nominal / efectiva", `${fmtPct(m.tir_nominal)} / ${fmtPct(m.tir_efectiva)}`],
              ["DSCR año 1 / 2", m.dscr ? m.dscr.map((x) => `${x.toFixed(2)}x`).join(" / ") : "n.d."],
              ["DSCR estrés −30%", m.dscr_estres ? m.dscr_estres.map((x) => `${x.toFixed(2)}x`).join(" / ") : "n.d."],
              ["Pasivo / Capital", m.pasivo_capital ? `${m.pasivo_capital.toFixed(2)}x` : "n.d."],
              ["Narrativa IA", memoJob.result.narrativa_ia ? `Sí (intento ${memoJob.result.intentos_ia})` : "No · A CONFIRMAR"]].map(([k, v]) => (
              <div key={k} className="border-t border-orange-500 pt-2"><dt className="text-[10px] uppercase tracking-widest text-zinc-500">{k}</dt><dd className="font-serif-display mt-1 text-lg font-bold">{v}</dd></div>
            ))}
          </dl>
        )}
      </div>
    </section>
  );
};
